import React from "react";

const SvgLinkedIn = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2573_6317)">
      <path
        d="M12.5 25.8008C19.4036 25.8008 25 20.2043 25 13.3008C25 6.39722 19.4036 0.800781 12.5 0.800781C5.59644 0.800781 0 6.39722 0 13.3008C0 20.2043 5.59644 25.8008 12.5 25.8008Z"
        fill="#007BB5"
      />
      <path d="M8.59375 9.39453H5.46875V20.332H8.59375V9.39453Z" fill="white" />
      <path
        d="M16.0148 9.39453C13.8344 9.39453 13.4594 10.1898 13.2812 10.957V9.39453H10.1562V20.332H13.2812V14.082C13.2812 13.0687 13.8305 12.5195 14.8438 12.5195C15.8328 12.5195 16.4062 13.057 16.4062 14.082V20.332H19.5312V14.8633C19.5312 11.7383 19.1242 9.39453 16.0148 9.39453Z"
        fill="white"
      />
      <path
        d="M7.03125 8.61328C7.8942 8.61328 8.59375 7.91373 8.59375 7.05078C8.59375 6.18784 7.8942 5.48828 7.03125 5.48828C6.16831 5.48828 5.46875 6.18784 5.46875 7.05078C5.46875 7.91373 6.16831 8.61328 7.03125 8.61328Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_2573_6317">
        <rect
          width="25"
          height="25"
          fill="white"
          transform="translate(0 0.800781)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default SvgLinkedIn;
